import type { ActivityFeedDataType } from './types.tsx';

export const transformData = (xmlDoc: Document): ActivityFeedDataType => {
	// @ts-expect-error - TS2304 - Cannot find name 'ActivityFeedItem'.
	const result: Array<ActivityFeedItem> = [];

	// Typecheck with project references identifies this as error but existing typecheck is not so doesnt allow ts-expect-error, so used ts-ignore
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore - Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator.
	for (const entry of xmlDoc.querySelectorAll('entry')) {
		const id = entry.querySelector('id')?.textContent ?? '';
		const published = entry.querySelector('published')?.textContent ?? '';
		const name = entry.querySelector('author > name')?.textContent ?? '';

		const title = entry.querySelector('title')?.textContent ?? '';
		const iconUrl =
			entry
				.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')
				?.getAttribute('href') ?? '';
		const content = entry.querySelector('content')?.textContent;

		const feedItem = {
			id,
			author: {
				name,
				avatarUrl: '',
			},
			published,
			title,
			iconUrl,
			content,
		};

		entry.querySelectorAll('author > link[rel=photo]').forEach((link: Element) => {
			if (link.getAttribute('media:height') === '48') {
				feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
			}
		});

		result.push(feedItem);
	}

	return result;
};
